App.controller('ProfileProtegesDetailsCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', '$stateParams', 'profileProtegesService', 'statesService', '$filter', function ($scope, $sce, $state, $http, Config, $mdDialog, $stateParams, profileProtegesService, statesService, $filter) {
    $scope.stateParams = $stateParams;

    $scope.typeProteges = $scope.stateParams.typeProteges;

    $scope.page = 'profile_proteges_details';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Edytuj: ' + $scope.stateParams.details.firstName + ' ' + $scope.stateParams.details.lastName;
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.profile_proteges.lists';
    $scope.$emit('link', $scope.link);

    $scope.searchTextLocalization = null;

    statesService.dataCityLists().then(function (data) {
        $scope.localizations = data.data;
    });

    getDeatils($scope.stateParams.details.id);

    function getDeatils(id) {
        $scope.data = {
            "pageNumber": 0
        }
        profileProtegesService.dataProtegesUser($scope.data).then(function (data) {
            $scope.allProtegesData = data.data.data;

            $scope.userProtegesData = $scope.allProtegesData.filter(
                function (item) {
                    return item.id === id;
                }
            )[0];

            console.log($scope.userProtegesData);

            $scope.email = $scope.userProtegesData.email;
            $scope.firstName = $scope.userProtegesData.firstName;
            $scope.lastName = $scope.userProtegesData.lastName;
            $scope.identifier = $scope.userProtegesData.identifier;
            $scope.id = $scope.userProtegesData.identifier;
            $scope.identifierType = ($scope.userProtegesData.citizenshipType === 'POLISH') ? 'PESEL' : 'OTHER';
            $scope.birthdate = ($scope.userProtegesData.citizenshipType !== 'POLISH') ? $filter('dateFormatter')(new Date($scope.userProtegesData.birthdate)) : $filter('getDateFromIdentifier')($scope.userProtegesData.identifier);
            $scope.phone = $scope.userProtegesData.phone;
            $scope.citizenshipType = $scope.userProtegesData.citizenshipType;
            $scope.otherCitizenship = $scope.userProtegesData.otherCitizenship;
            $scope.selectedItemLocalization = $scope.userProtegesData.address.city;
            $scope.street = $scope.userProtegesData.address.street;
            $scope.number = $scope.userProtegesData.address.number;
            $scope.apartment = $scope.userProtegesData.address.apartment;
            $scope.zipCode = $scope.userProtegesData.address.zipCode;
        });
    }

    $scope.edit = function () {
        var vm = this;

        console.log(vm.form);

        if (!vm.form.$valid) {
            return 0;
        }

        $scope.data = {
            id: $scope.id,
            email: $scope.email,
            address: {
                street: $scope.address.street,
                city: vm.form.city.$viewValue,
                number: $scope.address.number,
                apartment: $scope.address.apartment,
                zipCode: $scope.address.zipCode
            },
            phone: $scope.phone
        }

        profileProtegesService.editProtegesUser($scope.data).then(function (data) {
            console.log(data);
            if (data.status === 200) {
                $scope.password_current = '';
                vm.form.$setPristine();
                vm.form.$setUntouched();
                vm.form.$submitted = false;

                getDeatils($scope.stateParams.details.id);

                $scope.showPopUp('', 'Dane zostały zmienione', 'Twoje dane zostały zamienione pomyślnie.', 'Wróć do strony głównej', 'root.dashboard');
            } else {
                $scope.showPopUp('', 'Nie zmieniono danych', 'Wprowadziłeś błędne hasło lub dane są nieprawidłowe, spróbuj ponownie.', 'Ok', '');
            }
        });
    }

    $scope.showPopUp = function (ev, head, content, text, target) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function (data) {
            console.log(data);
        }, function () {

        });
    }

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.confirm = function () {
            $mdDialog.hide($scope.locals);
        };
    }

    // ##### LOCALIZATION FILTER ##### //
    $scope.querySearchLocalization = function (query) {
        var results = query ? $scope.localizations.filter(createFilterForLocalization(query)) : $scope.localizations;
        return results;
    };

    function createFilterForLocalization(query) {
        var lowercaseQuery = angular.lowercase(query);

        return function filterFn(items) {
            return (angular.lowercase(items.name).indexOf(lowercaseQuery) === 0);
        };
    };
}]);